module.exports = require("npm:https-browserify@0.0.0/index.js");